import { useEffect, useState } from "react";

export default function useOffsetY() {
    const [offsetY, setOffSetY] = useState(0)
    const handleScroll = () => setOffSetY(window.pageYOffset)

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    return { offsetY }
}